export default __webpack_public_path__ + "static/media/Blooded Fauld of the Mound.7d586573.jpg";